export default {
	propertyHousehold: '/domacnost-vlastnictvi',
	propertyLiability: '/domacnost-pripojisteni',
	propertyDetail: '/domacnost-detail',
	householdLiability: '/nemovitost-pripojisteni',
	householdDetail: '/nemovitost-detail',
	liabilityDetail: '/pripojisteni-detail',
	customerForm: '/zakaznicky-formular',
	final: '/podekovani',
}

export const urlToName = {
	'/domacnost-vlastnictvi': '',
	'/domacnost-pripojisteni': '',
	'/domacnost-detail': '',
	'/nemovitost-pripojisteni': '',
	'/nemovitost-detail': '',
	'/pripojisteni-detail': '',
	'/zakaznicky-formular': '',
	'/podekovani': '',
}
